import { contactDisplayName, isRawChannelId, UNKNOWN_CONTACT_NAME } from "@malfak/contracts";
import type { TFunction } from "i18next";

/**
 * QA F15: what to call a person. The API never sends a raw numeric Instagram id as a name (name → `@username` → the neutral
 * "Instagram user"); these helpers keep the web on the same rule and localize the neutral label.
 */
export function personName(t: TFunction, name: string | null | undefined, ...handles: (string | null | undefined)[]): string {
  const n = contactDisplayName(name, ...handles);
  return n === UNKNOWN_CONTACT_NAME ? t("people360.unknownName") : n;
}

/** `@username` when one is known (never a numeric id), else the person's name. */
export function personHandle(t: TFunction, handle: string | null | undefined, name: string | null | undefined): string {
  const h = (handle ?? "").trim().replace(/^@+/, "");
  if (h && !isRawChannelId(h)) return `@${h}`;
  return personName(t, name);
}
